import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  SelectPicker,
  DatePicker,
  RadioGroup,
  Radio,
  CheckPicker,
} from 'rsuite'
import { isRequired, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import moment from 'moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'

export default function ObligationOfInstallmentForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  handelPreview,
  clearValue,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [fromBudgetYearOptions, setFromBudgetYearOptions] = useState(schema.fromBudgetYear.options)
  const [toBudgetYearOptions, setToBudgetYearOptions] = useState(schema.toBudgetYear.options)
  const [startDates, setStartDates] = useState(null)
  const [endDates, setEndDates] = useState(null)

  useEffect(() => {
    console.log('schemaschema ', schema)
    if (!clearValue) {
      setStartDates(null)
      setEndDates(null)
      const indexOptionFromBudgetYear = schema.fromBudgetYear.options.length - 1
      const indexOptionToBudgetYear = schema.fromBudgetYear.options.length - 1

      setValue(
        schema.fromBudgetYear.name,
        schema.fromBudgetYear.options[indexOptionFromBudgetYear].value
      )
      setValue(schema.toBudgetYear.name, schema.toBudgetYear.options[indexOptionToBudgetYear].value)
    }
  }, [clearValue])

  const handleChangeBudgetYear = (name, value) => {
    if (value) {
      let bgy = getValues(name)
      if (!bgy) {
        setValue(name, value)
        clearErrors(name)
      } else if (name == schema.fromBudgetYear.name && bgy > value) {
        setValue(name, value)
      } else if (name == schema.toBudgetYear.name && bgy < value) {
        setValue(name, value)
      }

      if (name == schema.fromBudgetYear.name) {
        setFromBudgetYearOptions(schema.fromBudgetYear.options.filter((e) => e.value <= value))
      }

      if (name == schema.toBudgetYear.name) {
        setToBudgetYearOptions(schema.toBudgetYear.options.filter((e) => e.value >= value))
      }
    } else {
      if (name == schema.fromBudgetYear.name) {
        setFromBudgetYearOptions(schema.fromBudgetYear.options)
      }

      if (name == schema.toBudgetYear.name) {
        setToBudgetYearOptions(schema.toBudgetYear.options)
      }
    }
  }

  const Styles = {
    labelStyle: {
      marginTop: '5px',
      padding: '8px',
      textAlign: 'right',
    },
    inputStyle: {
      marginTop: '5px',
      padding: '8px',
    },
  }

  return (
    <>
      <Form id="mainContainer">
        <Row>
          {schema?.projectStartDate && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {schema.projectStartDate.label}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.projectStartDate.name]} />
                <Controller
                  key={schema.projectStartDate.name}
                  name={schema.projectStartDate.name}
                  control={control}
                  defaultValue={
                    schema.projectStartDate.value
                      ? moment(schema.projectStartDate.value, DATE_PICKER_FORMAT).toDate()
                      : null
                  }
                  // rules={isValidators(schema.preApprovedProjectStartDate.validators)}
                  render={(props) => {
                    return (
                      <DatePicker
                        format="DD/MM/YYYY"
                        locale={LOCAL_DAY_TH}
                        block
                        value={startDates}
                        onChange={(value) => {
                          const date = moment(value).format(DATE_PICKER_FORMAT)
                          props.onChange(value)
                          setStartDates(value)
                        }}
                        disabledDate={(date) =>
                          endDates && moment(endDates).isBefore(date, new Date())
                        }
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}

          {schema?.projectEndDate && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {schema.projectEndDate.label}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.projectEndDate.name]} />
                <Controller
                  key={schema.projectEndDate.name}
                  name={schema.projectEndDate.name}
                  control={control}
                  defaultValue={
                    schema.projectEndDate.value
                      ? moment(schema.projectEndDate.value, DATE_PICKER_FORMAT).toDate()
                      : null
                  }
                  // rules={isValidators(schema.preApprovedProjectEndDate.validators)}
                  render={(props) => {
                    return (
                      <DatePicker
                        format="DD/MM/YYYY"
                        locale={LOCAL_DAY_TH}
                        block
                        value={endDates}
                        onChange={(value) => {
                          const date = moment(value).format(DATE_PICKER_FORMAT)
                          props.onChange(value)
                          setEndDates(value)
                        }}
                        disabledDate={(date) =>
                          startDates && moment(startDates).isAfter(date, new Date())
                        }
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}
        </Row>
        <Row>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.fromBudgetYear.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <ErrorMessage error={errors[schema.fromBudgetYear.name]} />
            <Controller
              name={schema.fromBudgetYear.name}
              control={control}
              defaultValue={
                fromBudgetYearOptions
                  ? Math.max(...fromBudgetYearOptions.map((item) => item.value))
                  : schema.fromBudgetYear.value
              }
              rules={isValidators(schema.fromBudgetYear.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={fromBudgetYearOptions}
                    // disabled={disabledValue.fromBudgetYear}
                    value={props.value}
                    block
                    placeholder={`เลือก${schema.fromBudgetYear.label}`}
                    onChange={(value) => {
                      props.onChange(value)
                      handleChangeBudgetYear(schema.fromBudgetYear.name, value)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.toBudgetYear.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <ErrorMessage error={errors[schema.toBudgetYear.name]} />
            <Controller
              name={schema.toBudgetYear.name}
              control={control}
              defaultValue={
                toBudgetYearOptions
                  ? Math.max(...toBudgetYearOptions.map((item) => item.value))
                  : schema.toBudgetYear.value
              }
              rules={isValidators(schema.toBudgetYear.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={toBudgetYearOptions}
                    // disabled={disabledValue.toBudgetYear}
                    value={props.value}
                    block
                    placeholder={`เลือก${schema.toBudgetYear.label}`}
                    onChange={(value) => {
                      props.onChange(value)
                      handleChangeBudgetYear(schema.fromBudgetYear.name, value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.projectCode.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <Input
              name={schema.projectCode.name}
              defaultValue={schema.projectCode.value}
              placeholder={schema.projectCode.hint || `รหัสโครงการ`}
              inputRef={register()}
            />
          </Col>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.projectName.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <Input
              name={schema.projectName.name}
              defaultValue={schema.projectName.value}
              placeholder={schema.projectName.hint || `ชื่อโครงการ`}
              inputRef={register()}
            />
          </Col>
        </Row>

        <Row>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.granteeName.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <Input
              name={schema.granteeName.name}
              defaultValue={schema.granteeName.value}
              placeholder={schema.granteeName.hint || `ชื่อผู้รับทุน`}
              inputRef={register()}
            />
          </Col>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.granteeIdCard.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <Input
              name={schema.granteeIdCard.name}
              defaultValue={schema.granteeIdCard.value}
              placeholder={schema.granteeIdCard.hint || `เลขที่บัตรประชาชนผู้รับทุน`}
              inputRef={register()}
            />
          </Col>
        </Row>

        <Row>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.contractNo.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <Input
              name={schema.contractNo.name}
              defaultValue={schema.contractNo.value}
              placeholder={schema.contractNo.hint || `เลขที่ข้อตกลง`}
              inputRef={register()}
            />
          </Col>
          {schema.projectDepartment && (
            <>
              <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
                {schema.projectDepartment.label}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
                <ErrorMessage error={errors[schema.projectDepartment.name]} />
                <Controller
                  name={schema.projectDepartment.name}
                  control={control}
                  defaultValue={schema.projectDepartment.value}
                  // rules={isValidators(schema.projectDepartment.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={schema.projectDepartment.options}
                        // disabled={disabledValue.toBudgetYear}
                        value={props.value}
                        searchable={false}
                        block
                        placeholder={`เลือก${schema.projectDepartment.label}`}
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}
        </Row>
      </Form>
    </>
  )
}
